import { Pipe, PipeTransform } from '@angular/core';
import { Profile } from '../models/profile';
import { PROFILE_TYPE } from '../constants';
import { TranslateService } from '@ngx-translate/core';
import { environment } from 'src/environments/environment';
const { PAY_NOW_CARRIER_PROFILE_ID } = environment;

@Pipe({
  name: 'privacyProfile'
})
export class PrivacyProfilePipe implements PipeTransform {

  constructor(
    private translateService: TranslateService
  ) { }

  transform(value: Profile, args?: any): any {
    return getProfileIdentity(value, this.translateService)
  }
}

export const getProfileIdentity = (profile: Profile, translateService: TranslateService): string => {
  if (!profile) { return ''; }
  
  const { type = '', firstName = '', lastName = '', vatInfo = {} } = profile;
  const { companyName = '' } = vatInfo || {};

  const prefix = '';
  let name = '';

  switch (type) {
    case PROFILE_TYPE.private:
      name = `${firstName} ${lastName && lastName[0]}.`;
      break;
    case PROFILE_TYPE.professional: {
      if (companyName) {
        console.log('profile', profile);
        if (companyName.length > 5 && String(profile.id) != String(PAY_NOW_CARRIER_PROFILE_ID)) {
          name = `${companyName ? companyName.substring(0, 5) + '...' + ' ' + '-' + ' ' : ''}${
            translateService ? translateService.instant(`PROFESSIONAL`) : ''
          }`;
        } else {
          name = `${companyName + ' ' + '-' + ' '}${
            translateService ? translateService.instant(`PROFESSIONAL`) : ''
          }`;
        }
      } else {
        name = `${translateService ? translateService.instant(`PROFESSIONAL`) : ''}`;
      }
      break;
    }
    case PROFILE_TYPE.company: {
      if (companyName) {
        if (companyName.length > 5 && String(profile.id) != String(PAY_NOW_CARRIER_PROFILE_ID)) {
          name = `${companyName ? companyName.substring(0, 5) + '...' + ' ' + '-' + ' ' : ''}${
            translateService ? translateService.instant(`PROFILE_TYPE.company`) : ''
          }`;
        } else {
          name = `${companyName + ' ' + '-' + ' '}${
            translateService ? translateService.instant(`PROFILE_TYPE.company`) : ''
          }`;
        }
      } else {
        name = `${translateService ? translateService.instant(`PROFILE_TYPE.company`) : ''}`;
      }
      break;
    }
    default: {
      break;
    }
  }

  return prefix + name;
};
